import { View } from 'tamagui';

function Divider({ isBackgroundDark = false }: { isBackgroundDark?: boolean }) {
  return (
    <View
      my={'$space.xs'}
      borderTopWidth={'$borderWidth.hairline'}
      borderTopColor={
        isBackgroundDark ? '$color.panelTranslucent' : '$color.borderColor'
      }
    />
  );
}

export default Divider;
